import React, { useContext, useEffect } from "react";
import { Button } from "react-bootstrap";
import { ThemeContext } from "../../container/mppmodal/MppInfo";
import configuration from "../../configuration/configuration";

const MSFJumpScreen = ({msfPrimaryColors, mppModalProps}) => {

    const {
        flowType,
        queryValues,
        isSpinnerDisplayed,
        showMsfFlag,
        totalAmount,
        offerDisclaimer,
        offerStaticLanguage,
        offerRangeLanguage,
        tooltipDisclosure,
        offers,
        brandings: {
          mppPrimaryColors,
          preQual,
          availableOffersText,
          shopAvailableOffersText,
          prequalifyButtonText,
          applyButtonText,
        },
        brandings,
        openApplyHandler,
        openSetPayIn4,
        merchantName,
        syfToken,
        setPayIn4Info,
        partnerId,
        merchantNumber,
        getDevice,
        continueCallback,
        showMppAmountInputBox,
        subtitlempp,
        isMerchantApiFailed,
        queryValues: { d2dFlow },
        empqFlag,
        mppFromEmail,
        openPayLater,
        empqPaylaterMonthlyFlag,
        additionalInfo,
        softapplyEnabled,
        subtitleNoteSoftapplympp,
        orgPlatForm,
        clientName
      } = useContext(ThemeContext);

      const nonSetPayOffer = offers?.filter(
        (offerDetails) =>
          offerDetails.preferredOffer === "YES" &&
          !["SetPAYIn4", "SetPAY"].includes(offerDetails.offerType)
      );    
    
      const installmentOffer = offers?.filter(
        (offerDetails) =>
          offerDetails.preferredOffer === "YES" &&
          ["SetPAY"].includes(offerDetails.offerType)
      );

      const firePageLoadEvent = () => {
        window._SFDDL.pageInfo = {
          ClientName: merchantName,
          Country_Language: "US|ENG",
          CustomerType: "consumer",
          Device: getDevice,
          MerchantID: merchantNumber,
          PNL: "PS",
          PageFunction: "checkout",
          PageKind: "secondary lender option",
          PageName: "fortiva card",
          PageSubFunction: "",
          SiteIdentifier: "digitalpos",
          SyfPartnerID: partnerId,
          TokenId: syfToken
        };
      
        var event = document.createEvent("Event");
        event = new CustomEvent("syfPageView");
        event.initEvent("syfPageView");
        let retries = 0, maxRetries = 60;
        (function tryDispatch() {
          if (window.utag) {
            dispatchEvent(event);
          } else if(retries < maxRetries) {
            retries++;
            setTimeout(tryDispatch, 200);
          }
        })();
      }

      useEffect(() => {
        firePageLoadEvent();
      }, []);


      const ContinueCheckout = () => {
        console.log("ContinueCheckout=== from MSF Jump Screen");
        let url = configuration[window._syfMpp_.SYF_MPP_ENV].mppCheckout+"?syfCheckout=Y";
        const form = document.createElement("form");
        form.method = "POST";
        form.action = url;
    
        const requestParams = { ...queryValues, ...additionalInfo, softapplyEnabled, clientName: clientName || merchantName }
         const fetchMultiBuckets = { ...queryValues }
          Object.keys(requestParams).forEach((key) => {
    
          if (key === "flowType") {
            const hiddenField = document.createElement("input");
            hiddenField.type = "hidden";
            hiddenField.name = key;
            hiddenField.value = "MPPCONTINUECHECKOUT";
            form.appendChild(hiddenField);
          }
    
          if (
            [
              "passedJson",
              "syfPartnerId",
              "processInd",
              "childSyfMerchantNumber",
              "adobe_mc",
              "preQual",
              "prequalStatus",
              "productCategoryNames",
              "productCategoryNames1",
              "productCategoryNames2",
              "productCategoryNames3",
              "syfToken",
              "tokenId",
              "transactionToken",
              "transAmount1",
              "transAmount2",
              "transAmount3",
              "postbackid",
              "envUrl",
              "partnerId",
              "encryptKey",
              "modalType",
              "childPcgc",
              "childTransType",
              "pcgc",
              "partnerCode",
              "clientToken",
              "clientTransId",
              "cardNumber",
              "custFirstName",
              "custLastName",
              "expMonth",
              "expYear",
              "custZipCode",
              "custAddress1",
              "custAddress2",
              "phoneNumb",
              "appartment",
              "emailAddr",
              "custCity",
              "upeProgramName",
              "custState",
              "transPromo1",
              "transPromo2",
              "transPromo3",
              "iniPurAmt",
              "mid",
              "promotionalTags",
              "promotionalTags1",
              "promotionalTags2",
              "promotionalTags3",
              "offerNumber1",
              "offerNumber2",
              "offerNumber3",
              "description1",
              "description2",
              "description3",
              "initialAmount",
              "merchantDomainURL",
              "d2dFlow",
              "childSyfPartnerId",
              "partnerCode",
              "childSyfMerchantNumber",
              "saveCard",
              "showConsent",
              "DBuy",
              "promoOverRideFlag",
              "isEcartPromoOverRideAvailable",
              "storeMid",
              "softapplyEnabled",
              "merchantRefererUrl",
              "partnerProfileCode",
              "siteCode",
              "clientTransId",
              "clientName",
              "browserFriendlyPaymentToken",
              "editAmountOnConsumerOffer"
            ].includes(key)
          ) {
            const hiddenField = document.createElement("input");
             hiddenField.type = "hidden";
            hiddenField.name = key;
            hiddenField.value = requestParams[key];
            form.appendChild(hiddenField);
          }
        });
    
        if(fetchMultiBuckets['d2dFlow'] != 'undefined'  && fetchMultiBuckets['d2dFlow'] === 'Y'){
         if(!(fetchMultiBuckets['transAmount1'] === undefined || fetchMultiBuckets['transAmount1'] === null)){
                form['transAmount1'].value = fetchMultiBuckets['transAmount1'];
         }
         if(!(fetchMultiBuckets['transAmount2'] === undefined || fetchMultiBuckets['transAmount2'] === null)){
              form['transAmount2'].value = fetchMultiBuckets['transAmount2'];
          }
         if(!(fetchMultiBuckets['transAmount3'] === undefined || fetchMultiBuckets['transAmount3'] === null)){
             form['transAmount3'].value = fetchMultiBuckets['transAmount3'];
           }
        }
    
        if (setPayIn4Info) {
          const hiddenField = document.createElement("input");
          hiddenField.type = "hidden";
          hiddenField.name = "setPayIn4Info";
          hiddenField.value = JSON.stringify(setPayIn4Info);
          form.appendChild(hiddenField);
        }   
    
        if (empqFlag) {
          const hiddenField = document.createElement("input");
          hiddenField.type = "hidden";
          hiddenField.name = "empqFlag";
          hiddenField.value = empqFlag;
          form.appendChild(hiddenField);
    
          const applyHiddenField = document.createElement("input");
          applyHiddenField.type = "hidden";
          applyHiddenField.name = "modalapply";
          applyHiddenField.value = true;
          form.appendChild(applyHiddenField);
        }
    
        document.body.appendChild(form);
        form.submit();
        continueCallback();
      };

    const doMppCheckout = () => {
        console.log("doMppCheckout");
        if((nonSetPayOffer.length > 0 || installmentOffer.length > 0) && flowType === "CHECKOUT"){
            ContinueCheckout();
        }
    }

    const showMsfUI = () =>{
        console.log("starting msf checkout flow...");
        continueMsfCheckout();
      }

    const continueMsfCheckout = () => {
      console.log("ContinueCheckout=== from MSF Jump Screen");
      let url = configuration[window._syfMpp_.SYF_MPP_ENV].msfCheckout+"?requestOrigin=mpp&syfToken=" + syfToken+"&flowOrigin=MPP-Jumpscreen-Fortiva";
      const form = document.createElement("form");
      form.method = "POST";
      form.action = url;

      const hiddenField = document.createElement("input");
      hiddenField.type = "hidden";
      hiddenField.name = "flowType";
      hiddenField.value = "MPPCONTINUECHECKOUT";
      form.appendChild(hiddenField);
      document.body.appendChild(form);
      form.submit();
      //services.doSeamlessMsfApplyBuy(syfToken);
    }

    return (
        <div>

            <div className="col-md-12 col-xs-12 text-center  m-t-20" style={{paddingTop: '20px'}}> 
                <b><p>Continue with Fortiva® Retail Credit?</p></b>                
                <p>Checkout with your Fortiva® Retail Credit credit card.</p>
                <Button
                  className="btn btnPrimary btn-primary-msf-continue-checkout  prequaliBtn syfClickEvent"
                  data-object="button"
                  data-reason="USE FORTIVA RETAIL CARD"
                  data-type="Generic"
                  tabIndex="0"
                  style={{backgroundColor: msfPrimaryColors,borderColor: msfPrimaryColors}}
                  onClick={showMsfUI}>
                  USE FORTIVA RETAIL CARD
                </Button>

                <span className="or_hr">
                    <span className="or_hr_span">OR</span>
                </span>

                <div className="col-md-12 col-xs-12 text-center  m-t-20">                    
                  <b><a href="#" onClick={doMppCheckout} className="syfClickEvent" data-object="link" data-reason="Use  credit card" data-type="" style={{color:msfPrimaryColors, textDecoration: 'none', fontFamily:'Open Sans', fontSize:'16px', fontWeight:'700'}}>Use Different Partner Brand Credit Card</a></b>
                </div>
            </div>
                
        </div>
    );
}

export default MSFJumpScreen;
